import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DishServices } from '../../../dish/services';
import { Globals } from '../../../../globals';
import { MenuServices } from '../../../menu/services';
import { IngredientsServices } from '../../../ingredients/services';
import { ProvidersServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';
import { ProductsServices } from '../../../products/services';

/**
 * Generated class for the ProviderOrderAddDishPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-provider-order-add-dish',
  templateUrl: 'provider-order-add-dish.html',
})
export class ProviderOrderAddDishPage {
  quantity: any;
  uid: any;
  dishes: any = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    private dishServices: DishServices,
    public globals: Globals,
    private menuServices: MenuServices,
    private ingredientsServices: IngredientsServices,
    private providersServices: ProvidersServices,
    public translate: TranslateService,
    public productsServices: ProductsServices) {
    this.quantity = this.navParams.get('quantity');
    this.uid = this.navParams.get('uid');
    this.getDishes();
  }

  async getDishes() {
    var array = [];
    var menu = await this.menuServices.getMenu(this.uid);
    for (let element of this.globals.objectToArray(menu.sections)) {
      for (let dish of this.globals.objectToArray(element.dish)) {
        dish.quantity = this.quantity;
        array.push(dish);
      }
    }

    this.dishes = this.trim(array, 'name');
  }

  trim(arr, key) {
    var values = {};
    return arr.filter(function (item) {
      var val = item[key];
      var exists = values[val];
      values[val] = true;
      return !exists;
    });
  }

  add() {
    this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Add to cart - Create', this.globals.restaurant.email, 'Create/Update', 'Create  add to cart', 'ProviderOrders', 'menu');
    for (let element of this.dishes) {
      this.getInsertDishProduct(element.type, element.uid, element.quantity);
    }
    this.present();
  }

  insert(quantity, type, uid, insert) {
    //insert to cart
    this.ingredientsServices.afs.collection('cart').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'UID_USER': this.globals.user_uid,
      'quantity': quantity,
      'type': type,
      'uid': uid,
      'insert': insert,
    }).then(doc => {
      this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
    });
  }

  present() {
    //toast
    let toast = this.toastCtrl.create({
      message: this.translate.instant('instant-anadido-correctamente-cesta'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    //pop
    //this.providersServices.getTotalCartElements(this.globals.restaurant_uid);
    this.navCtrl.pop();
    this.navCtrl.pop();
  }

  async getInsertDishProduct(type, uid, quantity) {

    if (type == 'dish') {//dish
      var dish = await this.dishServices.getDish(uid);
      //
      for (let element of this.globals.objectToArray(dish.foodcost)) {
        var ingredient = await this.ingredientsServices.getIngredient(element.uid);
        if (ingredient.sub_recipe) {
          for (let ing_foodcost of this.globals.objectToArray(ingredient.foodcost)) {
            var _quantity_s = this.globals.calculateQuantity(quantity, ing_foodcost.quantity_gross / parseFloat(dish.foodcost_parts), ing_foodcost.measurement_static);
            this.insert(_quantity_s, 'ingredient', ing_foodcost.uid, 'dishmenu');
          }
        } else {
          var _quantity = this.globals.calculateQuantity(quantity, element.quantity_gross / parseFloat(dish.foodcost_parts), element.measurement_static);
          this.insert(_quantity, 'ingredient', element.uid, 'dishmenu');
        }
      }
    } else {//product
      var product = await this.productsServices.getProduct(uid);
      //
      if (product.sub_recipe) {//caso prod foodcost
        for (let element of this.globals.objectToArray(product.foodcost)) {
          var prod_ingredient = await this.ingredientsServices.getIngredient(element.uid);
          if (prod_ingredient.sub_recipe) {//caso foodcost
            for (let ing_foodcost of this.globals.objectToArray(prod_ingredient.foodcost)) {
              var _prod_quantity_s = this.globals.calculateQuantity(quantity, ing_foodcost.quantity_gross / parseFloat(product.foodcost_parts), ing_foodcost.measurement_static);
              this.insert(_prod_quantity_s, 'ingredient', ing_foodcost.uid, 'dishmenu');
            }
          } else {//caso no foodcost
            var _prod_quantity = this.globals.calculateQuantity(quantity, element.quantity_gross / parseFloat(product.foodcost_parts), element.measurement_static);
            this.insert(_prod_quantity, 'ingredient', element.uid, 'dishmenu');
          }
        }
      } else {//caso prod no foodcost
        this.insert(quantity, 'product', product.UID, 'dishmenu');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/providers/orders/provider-order-add-dish/provider-order-add-dish.ts